"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = require("containers/App/constants");
var Divider_1 = __importDefault(require("shared/components/Divider"));
var single_1 = require("utils/selectors/single");
var CreateCustomerModal_1 = __importDefault(require("../Modals/CreateCustomerModal"));
var hooks_1 = require("../Modals/CreateCustomerModal/hooks");
var MenuGroup_1 = __importDefault(require("./MenuGroup"));
var SettingsMenuItem_1 = __importDefault(require("./styles/SettingsMenuItem"));
var AccountantSettings = function (_a) {
    var onClick = _a.onClick;
    var _b = __read(react_1.default.useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = __read((0, hooks_1.useBackToMyFirm)(), 2), backToMyFirm = _c[0], isSwitching = _c[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var menuItems = react_1.default.useMemo(function () { return [profile.isAccountant && constants_1.MENU_ACCOUNTANTS, rechargerCompany && (0, constants_1.GET_MENU_RECHARGES)(rechargerCompany)].filter(end2end_1.notFalsy).flat(); }, [profile.isAccountant, rechargerCompany]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CreateCustomerModal_1.default, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); } }), (0, jsx_runtime_1.jsx)(MenuGroup_1.default, { categoryLabel: "Accountants portal", menuItems: menuItems, onCloseDropdown: onClick }), profile.isAccountant && ((0, jsx_runtime_1.jsx)(SettingsMenuItem_1.default, { onClick: function () { return setIsModalOpen(true); }, onCloseDropdown: onClick, label: "New customer account" })), backToMyFirm && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(SettingsMenuItem_1.default, { onClick: backToMyFirm, onCloseDropdown: onClick, disabled: isSwitching, label: "Back to accounting firm" })] }))] }));
};
exports.default = AccountantSettings;
